import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import type { Dispatch } from '@swf/core/store';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../../TakeABreakFromUs.scss';

import {
  TXTCLI_Logout,
  TXTWCL_Any_remaining_funds_will_be_au_ELL,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_6,
  TXTWCL_This_means_your_account_is_clo_ELL_1,
  TXTWCL_YouXll_be_able_to_request_to_r_ELL_2
} from './ExclusionResponseCAON.messages.json';

interface Props {
  indefiniteExclusion: boolean;
}

const ExclusionResponseCAON: React.FC<Props> = ({ indefiniteExclusion }) => {
  const { auth } = useDispatch<Dispatch>();

  return (
    <div>
      {indefiniteExclusion ? (
        <>
          <Translation {...TXTWCL_This_means_your_account_is_clo_ELL_1} />
          <Translation tagName="p" {...TXTWCL_Any_remaining_funds_will_be_au_ELL} />
        </>
      ) : (
        <>
          <Translation {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_6} />{' '}
          <Translation
            {...TXTWCL_YouXll_be_able_to_request_to_r_ELL_2}
            values={{
              a: (msg: string) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
              )
            }}
          />
        </>
      )}
      <StarsButton
        block
        translation={TXTCLI_Logout}
        className={styles.logoutButton}
        onClick={() => auth.logout()}
      />
    </div>
  );
};

export default ExclusionResponseCAON;
